import React, { useEffect, useState } from 'react'
import './App.scss'
import { connect } from 'react-redux'
import { IState } from './models/IState'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import {
    cardRenewRoute,
    guestPrivateRoutes,
    guestPublicRoutes,
    guestRegisterRoute,
    privateRoutes,
    publicRoutes
} from './routes'
import {
    GUEST_CARDS,
    GUEST_MAIN,
    GUEST_REGISTER,
    LOGIN_ROUTE,
    MAIN_ROUTE
} from './utils/routesConsts'
import LoadingLayout from './layout/LoadingLayout'
import Loader from './components/Loader'
import { get_locale } from './services/api'
import { ISiteDesign } from './models/IApiResponses'

interface AppProps {
    isAdminAuth: boolean
    isGuestAuth: boolean
    isLoading: boolean
    siteDesigns: ISiteDesign | null
}

const App: React.FC<AppProps> = ({ isAdminAuth, isGuestAuth, isLoading, siteDesigns }) => {

    const { pathname } = new URL(window.location.href)
    const [isLocaleLoaded, setIsLocaleLoaded] = useState<boolean>(false)

    useEffect(() => {
        if (!localStorage.getItem('currentLocale')) {
            get_locale().then(res => {
                let pageTitle = 'Get Wallet'
                switch (res.data?.locale) {
                    case 'RU':
                        localStorage.setItem('currentLocale', 'ru_RU')
                        break
                    case 'EN':
                        localStorage.setItem('currentLocale', 'en_EN')
                        break
                    default:
                        localStorage.setItem('currentLocale', 'ru_RU')
                        break
                }
                if (document != null) {
                    document.title = pageTitle
                }
                setIsLocaleLoaded(true)
            })
        } else {
            setIsLocaleLoaded(true)
        }
        //eslint-disable-next-line
    }, [])

    if (pathname.includes('/leave_feedback/')) {
        sessionStorage.setItem('path', pathname)
    }
    useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source');
  const utmTag = params.get('utm_tag');

  if (utmSource) localStorage.setItem('utm_source', utmSource);
  if (utmTag) localStorage.setItem('utm_tag', utmTag);

  // полезный лог на время отладки
  console.log('[App] UTM saved:', {
    utm_source: localStorage.getItem('utm_source'),
    utm_tag: localStorage.getItem('utm_tag'),
    search: window.location.search,
  });
}, []);

    if (isLoading) {
        return (
          <LoadingLayout>
              <Loader color={'#fff'} />
          </LoadingLayout>
        )
    }

    if (isLocaleLoaded) {
        // Перевыпуск карты Apple Wallet: гость приходит по ссылке с обратной стороны
        // старой карты, авторизации у него нет — проверяем до гостевых редиректов
        if (pathname.startsWith('/renew/')) {
            return (
              <Switch>
                  {cardRenewRoute.map(({ path, component }) => (
                    <Route
                      key={path}
                      path={path}
                      component={component}
                      exact={true}
                    />
                  ))}
              </Switch>
            )
        }

        if (pathname.includes('/admin')) {
            return isAdminAuth ? (
              <Switch>
                  {publicRoutes.map(({ path, component }) => (
                    <Route
                      key={path}
                      path={path}
                      component={component}
                      exact={true}
                    />
                  ))}
                  <Redirect to={MAIN_ROUTE} />
              </Switch>
            ) : (
              <Switch>
                  {privateRoutes.map(({ path, component }) => (
                    <Route
                      key={path}
                      path={path}
                      component={component}
                      exact={true}
                    />
                  ))}
                  <Redirect to={LOGIN_ROUTE} />
              </Switch>
            )
        } else {
            // ПРОВЕРКА: есть ли guestToken (после Telegram верификации)
            const hasGuestToken = localStorage.getItem('guestToken')

            // ПРОВЕРКА: завершена ли регистрация
            const isRegistrationCompleted = localStorage.getItem('isExsistingUser') === 'true'

            // Если есть guestToken И регистрация еще не завершена
            if (hasGuestToken && !isRegistrationCompleted) {
                return (
                  <Switch>
                      {guestRegisterRoute.map(({ path, component }) => (
                        <Route
                          key={path}
                          path={path}
                          component={component}
                          exact={true}
                        />
                      ))}
                      <Redirect to={GUEST_REGISTER} />
                  </Switch>
                )
            }

            // Основная логика маршрутизации для гостей
            const isGuestAuthorized = isGuestAuth ||
              isRegistrationCompleted ||
              hasGuestToken ||
              (sessionStorage.getItem('path') && localStorage.getItem('phone'))

            return isGuestAuthorized ? (
              <Switch>
                  {guestPrivateRoutes.map(({ path, component }) => (
                    <Route
                      key={path}
                      path={path}
                      component={component}
                      exact={true}
                    />
                  ))}
                  <Redirect to={
                      siteDesigns?.use_call_check === true &&
                      siteDesigns?.use_telegram_bot === false &&
                      siteDesigns?.use_telegram_check === false &&
                      siteDesigns?.capcha_check === false
                        ? '/verification'
                        : sessionStorage.getItem('path')
                          ? (sessionStorage.getItem('path') as string)
                          : GUEST_CARDS
                  }/>
              </Switch>
            ) : (
              <Switch>
                  {guestPublicRoutes.map(({ path, component }) => (
                    <Route
                      key={path}
                      path={path}
                      component={component}
                      exact={true}
                    />
                  ))}
                  <Redirect to={GUEST_MAIN} />
              </Switch>
            )
        }
    } else {
        return null
    }
}

function mapStateToProps(state: IState) {
    return {
        isAdminAuth: state.isAdminAuth,
        isGuestAuth: state.isGuestAuth,
        isLoading: state.isLoading,
        siteDesigns: state.siteDesigns
    }
}

export default withRouter(connect(mapStateToProps)(App))
